import { LogoMark } from "@/components/common/Logo/LogoMark"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { useLayoutStore } from "@/store/layoutStore"

export function ChatPanelButton() {
  const { translate } = useTranslation()
  const { chatPanelMode, openChatPanel, closeChatPanel } = useLayoutStore()
  const isOpen = chatPanelMode !== "closed"
  const label = translate(
    isOpen ? "AI_CHAT/PANEL/CLOSE" : "AI_CHAT/SHEET/TRIGGER_LABEL",
  )

  return (
    <Button
      size="icon"
      className={cn(
        "h-8 w-8 rounded-md bg-primary text-primary-foreground shadow-[0_0_12px_hsl(var(--primary)/0.35)] transition-shadow hover:bg-primary/90 hover:shadow-[0_0_18px_hsl(var(--primary)/0.55)]",
        isOpen && "ring-2 ring-primary/40",
      )}
      onClick={isOpen ? closeChatPanel : openChatPanel}
      aria-label={label}
      title={label}
    >
      <LogoMark className="h-4 w-5" aria-hidden="true" />
    </Button>
  )
}
